import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StarField from "../components/StarField";
import { setSeo } from "../lib/api";

export default function Terms() {
  useEffect(() => {
    setSeo(
      "Terms & Conditions | Shillong Lucky Ending",
      "Read the Terms & Conditions for using the Shillong Lucky Ending website. Lucky Ending results are for entertainment and informational purposes only."
    );
  }, []);

  return (
    <div data-testid="terms-page">
      <StarField />
      <Header />
      <div className="page-header">
        <h1>Terms &amp; Conditions</h1>
      </div>
      <div className="content-area">
        <div className="content-inner">
          <p>
            Welcome to <strong>Shillong Lucky Ending</strong>. By accessing or using this website, you agree to be
            bound by the following Terms &amp; Conditions. Please read them carefully. If you do not agree with any
            part of these terms, we kindly request that you discontinue use of the website immediately.
          </p>

          <h2>1. Informational Purpose Only</h2>
          <p>
            All content on this website, including the <strong>Lucky Ending</strong> results, old results chart,
            common numbers and related information, is provided strictly for <strong>entertainment and
            informational purposes</strong>. We do not operate, organise, promote or facilitate any form of betting,
            gambling or real-money gaming on this platform. The numbers displayed are references based on publicly
            discussed outcomes of the traditional archery game.
          </p>

          <h2>2. Age Restriction</h2>
          <p>
            This website is intended only for individuals who are <strong>18 years of age or older</strong>. By using
            this site you confirm that you meet this age requirement. Any real-world participation in archery-based
            games should comply fully with the laws of your region.
          </p>

          <h2>3. Accuracy of Information</h2>
          <p>
            While we make every reasonable effort to keep the results fast and accurate, we do not guarantee that the
            information on this website is always complete, current or error-free. Results may be delayed, updated or
            corrected without prior notice. You should always cross-verify with official sources before relying on
            any number.
          </p>

          <h2>4. No Guarantee of Outcomes</h2>
          <p>
            Past results, common numbers and dream numbers are purely historical or predictive references. They do
            not guarantee any future outcome. There is no method, formula or trick that can guarantee a win in any
            game of chance, and this website never claims otherwise.
          </p>

          <h2>5. Limitation of Liability</h2>
          <p>
            The website and its owners shall not be held responsible for any loss, damage or inconvenience, whether
            financial or otherwise, arising from the use of or reliance upon any information provided here. Use of
            this website is entirely at your own risk and discretion.
          </p>

          <h2>6. Changes to These Terms</h2>
          <p>
            We reserve the right to modify or update these Terms &amp; Conditions at any time without prior notice.
            Continued use of the website after any changes constitutes your acceptance of the revised terms.
          </p>

          <h2>7. Contact</h2>
          <p>
            If you have any questions regarding these Terms &amp; Conditions, please reach out to us through our{" "}
            <Link className="inlink" to="/contact"><strong>Contact Us</strong></Link> page. We are always happy to
            assist you. You may also read our <Link className="inlink" to="/privacy">Privacy Policy</Link> and learn
            more <Link className="inlink" to="/about">about the game</Link>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
